export default "__VITE_ASSET__C0ELBW_Z__"